// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-generate-gimel29_root__36LLr"};